module.exports = __webpack_public_path__ + "img/FR11808.551d3ece.png";